import styled from 'styled-components'
import colors from '../../../assets/colors'
import { tokens } from '../../../assets/tokens'

const BoxStyled = styled.div`
  .grid-container {
    background: #FFFFFF;
    box-shadow: 0px 4px 6px rgba(98, 102, 113, 0.06), 0px 2px 2px rgba(98, 102, 113, 0.06);
    border-radius: 6px;
    padding: 20px 30px;
  }

  @media print {
    .header-table {
      background: ${colors.white} !important;
      -webkit-print-color-adjust: exact;

      p {
        color: ${colors.white} !important;
      }
    }

    && {
      padding: 30px 24px !important;
    }
  }

  && {
    border-radius: 8px;
    padding-top: 24px;

    p {
      font-size: 13px;
      line-height: 20px;
      position: relative;
      display: inline-block;
    }

    .header-table {
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      padding: 15px 0;

      p {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        color: ${tokens.color.text.primary};
        margin-bottom: 0;

        svg {
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
          margin-right: 10px;
        }

        path {
          fill: ${props => props.theme.textPrimary};
        }
      }
    }

    .row-table {
      border-top: 1px solid ${colors.greyAlpha25};
      padding: 10px 0;
      :first-child {
        border-top: 0;
      }

      p {
        margin-bottom: 0;
      }

      /* Etiqueta 13/400 y valor 13/500: sin negritas fuertes */
      .title {
        font-weight: 400;
        font-size: 13px;
        line-height: 18px;
        color: ${tokens.color.text.secondary};
      }

      .value {
        font-weight: 500;
        font-size: 13px;
        line-height: 18px;
        text-align: right;
        color: ${tokens.color.text.primary};

        &.long {
          text-align: left !important;
        }
      }
    }
  }
`

export default BoxStyled
